<template>
    <x-page title="Group Role Report">
        <template #header-actions>
            <x-back-button
                :display-warning="false"
                :click-handler="handleBackButtonClick"
            />
            <x-excel-export-button :href="exportUrl" />
        </template>

        <x-filter-box :open="true" :readonly="true">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Group Roles">
                        <x-input-group-roles
                            v-model="filters.group_role_ids"
                            placeholder="Anggota"
                            :defaultParser="({ id }) => id"
                        />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Group Categories">
                        <x-input-group-categories
                            v-model="filters.group_category_ids"
                            placeholder="Semua"
                            :defaultParser="({ id }) => id"
                        />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>
    </x-page>
</template>

<script>
import XBackButton from "../../../components/XBackButton.vue";
import XExcelExportButton from "../../../components/XExcelExportButton.vue";
import XFilterBox from "../../../components/XFilterBox.vue";
import XFormGroup from "../../../components/XFormGroup.vue";
import XInputGroup from "../../../components/XInputGroup.vue";
import XInputGroupCategories from "../../../components/XInputGroupCategories.vue";
import XInputGroupRoles from "../../../components/XInputGroupRoles.vue";
import XPage from "../../../components/XPage.vue";

let defaultFilters = {
    group_role_ids: [],
    group_category_ids: [],
};

export default {
    components: {
        XPage,
        XFormGroup,
        XFilterBox,
        XBackButton,
        XInputGroup,
        XExcelExportButton,
        XInputGroupRoles,
        XInputGroupCategories,
    },
    computed: {
        exportUrl() {
            return `/admin/reports/group-roles?${$.param(this.filters)}`;
        },
    },
    data() {
        return {
            filters: { ...defaultFilters },
        };
    },
    methods: {
        handleBackButtonClick(router) {
            router.replace("/admin/reports");
        },
    },
};
</script>
